import { useState } from "react";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/radarWeatherMap.scss";

// Bootstrap Components
import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

// Map components
import TempMap from "../../mapcomponents/ts/tempMap";
import HumMap from "../../mapcomponents/ts/humMap";
import TideMap from "../../mapcomponents/ts/tideMap";
import WindMap from "../../mapcomponents/ts/windMap";
import GustMap from "../../mapcomponents/ts/gustMap";
import HourlyRainfallMap from "../../mapcomponents/ts/hourlyRainfallMap";
// END

// Material
import Switch from "@mui/material/Switch";
import { FormControlLabel } from "@mui/material";

const windyLink = process.env.REACT_APP_MAP_WINDY_APP_LINK;

export default function RadarWeatherMap() {
  const [TempMapEnable, setTempMapEnable] = useState<number>(0);
  const [HumMapEnable, setHumMapEnable] = useState<number>(0);
  const [WindMapEnable, setWindMapEnable] = useState<number>(0);
  const [GustMapEnable, setGustMapEnable] = useState<number>(0);
  const [TideMapEnable, setTideMapEnable] = useState<number>(0);
  const [HourlyRainFallMapEnable, setHourlyRainFallEnable] =
    useState<number>(0);

  const [isAutoUpdate, setIsAutoUpdate] = useState<boolean>(false);

  // UI components
  function handleSelect(key: string | null) {
    setTempMapEnable(0);
    setHumMapEnable(0);
    setWindMapEnable(0);
    setGustMapEnable(0);
    setTideMapEnable(0);
    setHourlyRainFallEnable(0);

    switch (key) {
      case "radar":
        break;
      case "temp":
        setTempMapEnable(1);
        break;
      case "hum":
        setHumMapEnable(1);
        break;
      case "wind":
        setWindMapEnable(1);
        break;
      case "gust":
        setGustMapEnable(1);
        break;
      case "tide":
        setTideMapEnable(1);
        break;
      case "rainfall":
        setHourlyRainFallEnable(1);
        break;
      default:
        break;
    }
  }

  function handleAutoUpdateSwitch() {
    setIsAutoUpdate((prev) => !prev);
  }

  return (
    <Container>
      <div id="radarWeatherMapBox">
        <div id="radarWeatherMapBox_Title">
          <div id="radarWeatherMapBox_Title_LeftItem">現在天氣及圖像</div>
          <div id="radarWeatherMapBox_Title_RightItem">
            <FormControlLabel
              control={
                <Switch
                  color="default"
                  id="autoUpdateSwitch"
                  checked={isAutoUpdate}
                  onChange={handleAutoUpdateSwitch}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "blue", // track color
                    },
                  }}
                />
              }
              label="自動更新"
            />
          </div>
        </div>

        <div id="radarWeatherMapBox_Tabs">
          <Tabs defaultActiveKey="radar" onSelect={(Key) => handleSelect(Key)}>
            <Tab
              eventKey="radar"
              title="綜合雷達(windy.com)"
              id="radarWeatherMapBox_radar"
            >
              <iframe
                width="100%"
                height="625px"
                title="windyRadarPage"
                src={windyLink}
              />
            </Tab>

            <Tab eventKey="temp" title="氣溫">
              <TempMap enable={TempMapEnable} autoUpdate={isAutoUpdate} />
            </Tab>

            <Tab eventKey="hum" title="濕度">
              <HumMap enable={HumMapEnable} autoUpdate={isAutoUpdate} />
            </Tab>

            <Tab eventKey="wind" title="風速風向">
              <WindMap enable={WindMapEnable} autoUpdate={isAutoUpdate} />
            </Tab>

            <Tab eventKey="gust" title="1小時最大陣風">
              <GustMap enable={GustMapEnable} autoUpdate={isAutoUpdate} />
            </Tab>

            <Tab eventKey="rainfall" title="1小時雨量">
              <HourlyRainfallMap
                enable={HourlyRainFallMapEnable}
                autoUpdate={isAutoUpdate}
              />
            </Tab>

            <Tab eventKey="tide" title="潮位">
              <TideMap enable={TideMapEnable} autoUpdate={isAutoUpdate} />
            </Tab>
          </Tabs>
        </div>
      </div>
    </Container>
  );
}
